export const SET_PROVIDER = 'SET_PROVIDER';

export const REMOVE_PROVIDER = 'REMOVE_PROVIDER';